import React from 'react';

import { Bolt, ExclamationCircle, MapMarkedAlt, TemperatureHigh } from '@styled-icons/fa-solid';
function AnomalyDetect(props: any) {
  return (
    <div>
      <span>Hz</span>
      <TemperatureHigh size="16" style={{ paddingLeft: "4px", color: "gray" }} />
      <MapMarkedAlt size="16" style={{ paddingLeft: "4px", color: "gray" }} />
      <Bolt size="16" style={{ paddingLeft: "4px", color: "gray" }} />
      <ExclamationCircle size="16" style={{ paddingLeft: "4px", color: "gray" }} />
    </div>
  )
}

export default (AnomalyDetect);
